import React from 'react';
import { bool, func, oneOf, object, shape, number, string } from 'prop-types';
import { searchStateShape } from './shapes';
import { createAlgoliaApp } from './utils';
import { InstantSearchRoot, App } from './modules';
import translationsMap from './translations';
import { LOCALES } from './constants';

export default function Listing({ state: initialState, translations }) {
    const {
        resultsState,
        searchState,
        ssrRender,
        data,
        platform,
        user,
        environmentVariables,
        rerankingConfig,
        otherProps,
    } = initialState;
    const searchClient = createAlgoliaApp({
        appId: data.algolia.app_id,
        searchApiKey: data.algolia.search_api_key,
        isSSR: ssrRender,
        rerankingConfig,
    });

    return (
        <App
            ssrData={{
                ...data,
                platform,
                user,
                environmentVariables,
            }}
            resultsState={resultsState}
            searchClient={searchClient}
            searchState={searchState}
            location={data?.location}
            translations={translations || translationsMap[platform]}
            {...otherProps}
        >
            <InstantSearchRoot ssrRender={ssrRender} />
        </App>
    );
}

const dataShape = shape({
    listingData: shape({
        type: oneOf(['category', 'search', 'brand']),
        params: shape({
            id: number,
            level: number,
        }),
        category: shape({
            id: number,
            level: number,
        }),
        query: string,
    }),
    algolia: shape({
        app_id: string.isRequired,
        search_api_key: string.isRequired,
        indexes: shape({
            discount: string.isRequired,
            price_asc: string.isRequired,
            price_desc: string.isRequired,
            relevance: string.isRequired,
        }),
    }).isRequired,
});

Listing.propTypes = {
    state: shape({
        searchState: searchStateShape.isRequired,
        resultsState: object, // eslint-disable-line react/forbid-prop-types
        ssrRender: bool,
        data: dataShape.isRequired,
    }),
    translations: shape({
        messages: object,
        addLocaleData: func.isRequired,
        locale: oneOf(Object.values(LOCALES)),
    }).isRequired,
};

Listing.defaultProps = {
    state: undefined,
};
